import { polygon, featureCollection, kinks, intersect, area } from '@turf/turf';

// Client-side UX pre-check only; the DB trigger is authoritative.
// selfIntersects: drawn ring crosses itself.
// overlapsExisting: positive-area intersection with any existing polygon
// (a shared edge / wall has zero intersection area and is allowed).
export function checkPolygon(drawnGeometry, existingGeometries) {
  const drawn = polygon(drawnGeometry.coordinates);
  const selfIntersects = kinks(drawn).features.length > 0;

  let overlapsExisting = false;
  for (const g of existingGeometries || []) {
    const inter = intersect(featureCollection([drawn, polygon(g.coordinates)]));
    if (inter && area(inter) > 0) { overlapsExisting = true; break; }
  }
  return { selfIntersects, overlapsExisting };
}
